import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import axios from "axios";
import config from "../../Common/Configurations/APIConfig";
import { handleSuccess, handleError } from "../../Common/Layout/CustomAlerts";

const initialFieldValues = {
  serviceTaskId: "",
  amount: "",
  paymentStatus: "",
  paymentMethod: "",
};

export default function UpdatePayment({ onClose, headerconfig, payment }) {
  const [values, setValues] = useState(initialFieldValues);
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (payment) {
      setValues({
        serviceTaskId: payment.serviceTaskId,
        amount: payment.amount,
        paymentStatus: payment.paymentStatus,
        paymentMethod: payment.paymentMethod || "",
      });
    }
  }, [payment]);

  const validate = () => {
    const temp = {
      amount: values.amount !== "" && !isNaN(values.amount),
      paymentStatus: values.paymentStatus !== "",
    };
    setErrors(temp);
    return Object.values(temp).every(Boolean);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setValues({ ...values, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validate()) return;

    setIsSubmitting(true);
    const formData = new FormData();
    formData.append("serviceTaskId", values.serviceTaskId);
    formData.append("amount", values.amount);
    formData.append("paymentStatus", values.paymentStatus);
    formData.append("paymentMethod", values.paymentMethod);

    axios
      .put(config.APIACTIVATEURL + config.PAYMENTUPDATEBYADMIN, formData, {
        ...headerconfig,
      })
      .then((res) => {
        if (res.data.statusCode === 200) {
          handleSuccess("Payment updated successfully");
          onClose();
        } else {
          handleError(res.data.data);
        }
      })
      .catch(() => handleError("Error updating payment"));
  };

  return (
    <Modal show onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>Update Payment</Modal.Title>
      </Modal.Header>
      <form onSubmit={handleSubmit}>
        <Modal.Body>
          <div className="mb-3">
            <label className="form-label">Amount</label>
            <input
              type="number"
              name="amount"
              className={`form-control ${
                errors.amount === false ? "is-invalid" : ""
              }`}
              value={values.amount}
              onChange={handleChange}
            />
            {errors.amount === false && (
              <div className="invalid-feedback">Enter valid amount</div>
            )}
          </div>

          <div className="mb-3">
            <label className="form-label">Payment Status</label>
            <select
              name="paymentStatus"
              className={`form-select ${
                errors.paymentStatus === false ? "is-invalid" : ""
              }`}
              value={values.paymentStatus}
              onChange={handleChange}
            >
              <option value="">Select Status</option>
              <option value="PENDING">PENDING</option>
              <option value="SUCCESS">SUCCESS</option>
            </select>
            {errors.paymentStatus === false && (
              <div className="invalid-feedback">Select a status</div>
            )}
          </div>

          <div className="mb-3">
            <label className="form-label">Payment Method</label>
            <select
              id="paymentMethod"
              name="paymentMethod"
              className="form-select"
              value={values.paymentMethod}
              onChange={handleChange}
            >
              <option value="">All </option>
              <option value="UPI">UPI</option>
              <option value="NETBANKING">NETBANKING</option>
              <option value="CREDITCARD">CREDITCARD</option>
              <option value="DEBITCARD">DEBITCARD</option>
              <option value="PAYPAL">PAYPAL</option>
              <option value="RAZORPAY">RAZORPAY</option>
              <option value="OTHERS">OTHERS</option>
            </select>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" type="submit" disabled={isSubmitting}>
            {isSubmitting ? "Updating..." : "Update"}
          </Button>
          <Button variant="danger" onClick={onClose}>
            Cancel
          </Button>
        </Modal.Footer>
      </form>
    </Modal>
  );
}
